(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-spela/assets/coupon-choice/coupon-toolbox/video-analysis-container.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-spela/assets/coupon-choice/coupon-toolbox/video-analysis-container.js');
"use strict";


const {
  useCallback,
  useContext
} = React;
const {
  DrawContext
} = svs.components.tipsen.drawProvider;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  selectCurrentVideo,
  selectDrawVideo,
  selectPlaybackState
} = svs.components.tipsen.store.reducers.videoAnalysesSlice.selectors;
const {
  setCurrentVideo
} = svs.components.tipsen.store.reducers.videoAnalysesSlice.actions;
const {
  VideoAnalysisButton
} = svs.components.tipsen.videoAnalysisButton;
const VideoAnalysisContainer = () => {
  const dispatch = useDispatch();
  const {
    productId,
    drawNumber
  } = useContext(DrawContext);
  const drawVideoAnalysis = useSelector(state => selectDrawVideo(state, drawNumber, productId));
  const currentVideo = useSelector(selectCurrentVideo);
  const playbackState = useSelector(selectPlaybackState);
  const isCurrentlySet = currentVideo && drawVideoAnalysis && currentVideo.id === drawVideoAnalysis.id;
  const isPending = isCurrentlySet && !playbackState.isReady;
  const isPlaying = isCurrentlySet && playbackState.isPlaying;
  const isPaused = isCurrentlySet && playbackState.isReady && !playbackState.isPlaying;
  const progress = playbackState.progress || 0;
  const handlePlayToggle = useCallback(e => {
    e.preventDefault();
    if (isPending) {
      return;
    }
    dispatch(setCurrentVideo(isCurrentlySet ? null : drawVideoAnalysis));
  }, [isPending, dispatch, isCurrentlySet, drawVideoAnalysis]);
  const isDisabled = !drawVideoAnalysis;
  const ariaLabel = "".concat(isPlaying || isPaused ? 'Stäng' : 'Öppna', " videoanalys f\xF6r kupongen");
  const title = "".concat(isPlaying || isPaused ? 'Stäng' : 'Öppna', " videoanalys f\xF6r kupongen");
  return React.createElement(VideoAnalysisButton, {
    ariaLabel: ariaLabel,
    disabled: isDisabled,
    isPaused: isPaused,
    isPending: isPending,
    isPlaying: isPlaying,
    onClick: handlePlayToggle,
    progress: progress,
    title: isDisabled ? 'Videoanalys för kupongen är inte tillgänglig' : title
  });
};
setGlobal('svs.components.tipsen.routePlaySpela.couponChoice.VideoAnalysisContainer', VideoAnalysisContainer);

 })(window);